export const DoNotRunIcon = () => (
  <svg width="82" height="22" viewBox="0 0 82 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M82 0H0V18.0857H82V0Z" fill="#FDB714" />
    <path d="M7 22V18.0857H0L7 22Z" fill="#C3882B" />
    <text
      x="42"
      y="12.5"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="9"
      fontWeight="700"
      fill="black"
    >
      Do Not Run
    </text>
  </svg>
);
